import { useEffect, useState } from 'react';
import { Icon } from '../../../../core/components/atoms/Icon';

const Select = (props: ISelect) => {
  const { options, placeholder, value, onChange } = props;
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!value) return;
    const option = options.find((option) => option.value === value);
    setSelected(option?.label || placeholder);
  }, [value, options]);

  return (
    <div className='relative w-48'>
      {/* Botão principal */}
      <button
        onClick={() => setOpen(!open)}
        className='flex w-full items-center justify-between rounded-pill bg-[#B9C1C9] px-4 py-2 text-xs  text-[#2C3E50] shadow-level-1 transition'
      >
        {selected}
        <Icon
          type='material'
          Icon='chevron_right'
          className='h-[12px] w-[8px] text-xs text-[#3E4752]'
        />
      </button>

      {/* Dropdown */}
      {open && (
        <div className='border absolute z-10 mt-2 w-full rounded-lg border-[#E5E7EB] bg-[#FFFFFF] shadow-level-1'>
          {options.map((option, i) => (
            <div
              key={i}
              onClick={() => {
                setSelected(option.label);
                onChange(option.value);
                setOpen(false);
              }}
              className='cursor-pointer px-4 py-2 text-sm text-[#2C3E50] transition hover:bg-[#F1F3F8]'
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default Select;
